module.exports = __webpack_public_path__ + "img/ml3.284ffb3e.jpg";